import { useEffect, type ReactNode } from "react";
import { useAppSelector } from "@/store/hooks";

interface ThemeProviderProps {
  children: ReactNode;
}

// Applies the current org's theme as CSS variables on <html>,
// UNLESS the current user is SUPER_ADMIN — Super Admin always keeps
// the fixed platform brand (orange/navy) defined in index.css.
export function ThemeProvider({ children }: ThemeProviderProps) {
  const user = useAppSelector((state) => state.auth.user);
  const orgTheme = useAppSelector((state) => state.theme.orgTheme);

  useEffect(() => {
    const root = document.documentElement;

    if (user?.role?.scope === "SUPER_ADMIN") {
      // Super Admin: remove any override, use index.css defaults
      root.style.removeProperty("--primary");
      root.style.removeProperty("--primary-foreground");
      root.style.removeProperty("--secondary");
      root.style.removeProperty("--accent");
      return;
    }

    // Every other role: apply this org's chosen theme
    root.style.setProperty("--primary", orgTheme.primary);
    root.style.setProperty("--primary-foreground", orgTheme.primaryForeground);
    root.style.setProperty("--secondary", orgTheme.secondary);
    root.style.setProperty("--accent", orgTheme.accent);
  }, [user, orgTheme]);

  return <>{children}</>;
}